import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ManualChargeContMain from "presentation/view/container/ManualCharge/ManualChargeContMain";

CommonEntrypoint(<ManualChargeContMain/>)